<template>
  <div>
    <v-data-table
      :headers="computed_headers"
      :items="computed_items"
      class="elevation-0"
      ref="table"
      :mobile-breakpoint="1"
      :search="null"
      hide-default-footer
    >
      <template v-slot:top>
        <v-row align="center" justify="space-between">
          <v-col xs="12" md="5" lg="4" align="center" class="pl-3" v-if="!disable_local_search">
            <v-text-field v-model="search" prepend-icon="mdi-magnify" label="Pesquisar"></v-text-field>
          </v-col>
          <v-col cols="2" class="pa-0 ma-0">
            <slot name="filter"></slot>
          </v-col>
          <v-col cols="12" md="5" lg="6" class="pa-0 pr-10">
            <slot name="sumarized"></slot>
          </v-col>
        </v-row>
      </template>

      <template v-slot:item.ammount="{item}">
        R$ {{Number(item.ammount) | toCurrency}}
      </template>
      <template v-slot:item.secure_url="{item}">
        <!-- <v-chip pill>

            <v-icon>mdi-network</v-icon>

          <a :href="`${item.secure_url}`" target="_blank"></a>
        </v-chip> -->
        <v-btn text fab small color="primary" :href="item.secure_url" target="_blank" rounded><v-icon>mdi-network</v-icon></v-btn>
      </template>
      <template v-slot:item.status="{item}">
        <v-chip pill v-if="status[item.status]">
          <v-avatar left :class="status[item.status].avatar_color">
            <v-icon>{{status[item.status].icon}}</v-icon>
          </v-avatar>
          {{status[item.status].text}}
        </v-chip>
        <v-chip pill color="grey" v-else>
          <v-avatar left class="grey">
            <v-icon>mdi-help</v-icon>
          </v-avatar>
          {{item.status}}
        </v-chip>
      </template>
      <template v-slot:item.due_date="{item}">
        {{new Date(`${item.due_date}T12:00:00Z`).toLocaleDateString("pt-BR")}}
      </template>
      <template v-slot:item.created_at="{item}">
        {{new Date(item.created_at).toLocaleDateString("pt-BR")}}
      </template>
      <template v-slot:item.action="{ item }">
        <!-- <v-icon class="btn_duplicate mr-2" v-if="can_duplicate" @click="duplicateItem(item)" >mdi-content-copy</v-icon> -->
        <v-icon class="btn_edit mr-2" @click="editItem(item)" >mdi-circle-edit-outline</v-icon>
        <v-icon class="btn_copy mr-2" @click="copyBillUrl(item)" v-if="$route.name == 'Bills'" color="purple">mdi-link</v-icon>
        <v-icon class="btn_delete" @click="deleteItem(item)" v-if="deletion_enabled" >mdi-delete </v-icon>
      </template>
      <template v-slot:bottom>
        <v-row v-if="$route.name == 'Bills'">
          <v-chip>
            <v-avatar class="success"><v-icon color="white">mdi-currency-brl</v-icon></v-avatar>
            {{total_ammount}}
          </v-chip>
        </v-row>
      </template>

      <!-- FOR Suppliers -->
      <template v-slot:item.tag_list="{item}">
        <v-chip small color="brown lighten-4" class="ma-1" style="text-transform:capitalize;" v-for="(tag, index) in item.tag_list" :key="index">{{tag}}</v-chip>
      </template>

      <template v-slot:item.phones="{item}">
        <v-chip  class="ma-1" small color="blue-grey lighten-4" v-for="(tag, index) in item.phones" :key="index">{{tag}}</v-chip>
      </template>

      <template v-slot:no-data>
        <div class="text-center pa-4">
          <v-icon large color="grey">mdi-inbox</v-icon>
          <p class="mt-2 grey--text">Nenhum registro encontrado</p>
        </div>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'

export default {
  name: 'IndexTable',
  props: {
    deletion_enabled: {
      default: true,
      type: Boolean
    },
    headers: {
      type: Array,
    },
    items: {
      type: Array,
    },
    disable_local_search: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      search: null,
      data_headers: [
        { text: 'Descrição', width: '80%' ,align: 'left', sortable: false, value: 'name'},
        // { text: 'Dado 1', value: 'calories' },
        // { text: 'Dado 2', value: 'fat' },
        // { text: 'Dado 3', value: 'carbs' },
        // { text: 'Dado 4', value: 'protein' },
        { text: 'Ação', value: 'action', sortable: false },
      ],

      status:{
        pending: {icon: "mdi-account-clock", text: "Pendente", avatar_color: "orange"},
        paid: {icon: "mdi-account-check", text: "Pago", avatar_color: "green"},
        cancelled: {icon: "mdi-cancel", text: "Cancelado", avatar_color: "grey"},
        overdue: {icon: "mdi-alarm-off", text: "Atrasado", avatar_color: "red"},
        manual_payed: {icon: "mdi-hand", text: "Pg. Manual", avatar_color: "blue"},
        error: {icon: "mdi-alert-circle", text: "Erro", avatar_color: "red darken-2"},
        processing: {icon: "mdi-cog", text: "Processando", avatar_color: "blue-grey"},
      },
    }
  },
  methods: {
    editItem(i) {
      this.$emit('editing', i.id)
    },
    deleteItem(i) {
      (async () => {
				const { value: confirmation } = await this.$swal({
          title: "Excluir esse registro?",
          text: 'Essa ação é irreversível',
					type: "question",
					showCancelButton: true,
					confirmButtonText: 'Sim',
					confirmButtonColor: '#ff9800',
					cancelButtonText: 'Não',
				})

				if (confirmation) {
          this.$emit('deleting', i.id)
				}
				}
			)()
    },
    copyBillUrl(item) {
      // Emitir evento para o componente pai lidar com a cópia da URL
      this.$emit('copy-bill-url', item.id)
    },
    ...mapActions({
      // function: 'Module/action'
    })
  },
  computed: {
    computed_headers() {
      return this.headers? this.headers : this.data_headers
    },
    computed_items() {
      if (this.disable_local_search || !this.search) {
        return this.items? this.items : []
      }
      // Aplicar busca local apenas se não estiver desabilitada
      return this.items ? this.items.filter(item => {
        return Object.values(item).some(value =>
          value && value.toString().toLowerCase().includes(this.search.toLowerCase())
        )
      }) : []
    },
    total_ammount() {
      if (this.$route.name == 'Bills' && this.computed_items.length>0){
        var all_data = this.computed_items
        var b = all_data? all_data.map(d => Number(d.ammount)).reduce((x,z) => x+z, 0) : null
        return b? b : 0
      }
    },
    ...mapState({
      // data: state=> state.Module.state_var
    })
  },
  watch: {
    data(nv,ov) {
      if (nv){
      } else if (nv == false){
      }
    }
  },
}
</script>

<style scoped>
.btn_duplicate:hover{
  color: purple
}
.btn_edit:hover{
  color: #2196F3
}
.btn_copy:hover{
  color: #9C27B0
}
.btn_delete:hover{
  color: red
}
</style>